import api from "./api";

const unwrap = (res) => res?.data ?? null;

export const getNotifications = async () =>
    unwrap(await api.get("/notifications"));

export const markNotificationAsRead = async (id) =>
    unwrap(await api.put(`/notifications/${id}/read`));

export const markAllNotificationsAsRead = async () =>
    unwrap(await api.put("/notifications/read-all"));

export default {
    getNotifications,
    markNotificationAsRead,
    markAllNotificationsAsRead,
};